module.exports = __webpack_public_path__ + "static/media/armored_train.85a13ffb.jpg";